import { fetchCombo } from './coreapi';

let phaseCache: any[] | null = null;
let pendingRequest: Promise<any[]> | null = null;

export const fetchPlanningJourneyPhases = async (
  forceRefresh = false,
): Promise<any[]> => {
  if (!forceRefresh && phaseCache) return phaseCache;
  if (!forceRefresh && pendingRequest) return pendingRequest;

  pendingRequest = fetchCombo('planningcyclephase')
    .then((result) => {
      phaseCache = [...result].sort( //ERNIE: sorting already done in db
        (a:any, b:any) =>
          Number(a.raw?.sor ?? a.sor ?? 0) -
          Number(b.raw?.sor ?? b.sor ?? 0),
      );
      return phaseCache;
    })
    .finally(() => {
      pendingRequest = null;
    });

  return pendingRequest;
};

export const clearPlanningJourneyPhaseCache = () => {
  phaseCache = null;
};

export const getCachedPlanningJourneyPhases = (): any[] =>
  phaseCache ? [...phaseCache] : [];
